import { type NavigationItem } from './navigation.models';
import { VA_CAPABILITIES } from '../../features/vacations/vacation.models';

export const PRIMARY_NAVIGATION: readonly NavigationItem[] = [
  {
    id: 'home',
    label: 'Inicio',
    icon: '⌂',
    route: '/',
  },
  {
    id: 'employees',
    label: 'Empleados',
    icon: '♙',
    route: '/employees',
    requiredPermission: 'empleados.ver',
  },
  {
    id: 'administration',
    label: 'Administración',
    icon: '⚙',
    children: [
      {
        id: 'users',
        label: 'Usuarios',
        icon: '♙',
        route: '/administration/users',
        requiredPermission: 'usuarios.ver',
      },
      {
        id: 'roles',
        label: 'Roles',
        icon: '▦',
        route: '/administration/roles',
        requiredPermission: 'roles.ver',
      },
    ],
  },
  {
    id: 'payroll',
    label: 'Prenómina',
    icon: '▦',
    children: [
      {
        id: 'payroll-periods',
        label: 'Períodos',
        icon: '◷',
        route: '/payroll/periods',
        requiredPermission: 'prenomina.periodos.ver',
      },
      {
        id: 'vacations-general', label: 'Vacaciones', icon: '◷', route: '/vacations',
        requiredAnyPermission: VA_CAPABILITIES,
      },
    ],
  },
  {
    id: 'labor-catalogs',
    label: 'Catálogos laborales',
    icon: '▤',
    children: [
      {
        id: 'employer-registrations',
        label: 'Registros patronales',
        icon: '◫',
        route: '/labor-catalogs/employer-registrations',
        requiredPermission: 'catalogos_laborales.ver',
      },
      {
        id: 'contractors',
        label: 'Contratistas',
        icon: '◇',
        route: '/labor-catalogs/contractors',
        requiredPermission: 'catalogos_laborales.ver',
      },
      {
        id: 'projects',
        label: 'Obras',
        icon: '▧',
        route: '/labor-catalogs/projects',
        requiredPermission: 'catalogos_laborales.ver',
      },
      {
        id: 'departments',
        label: 'Departamentos',
        icon: '▥',
        route: '/labor-catalogs/departments',
        requiredPermission: 'catalogos_laborales.ver',
      },
    ],
  },
  {
    id: 'labor-configuration',
    label: 'Configuración laboral',
    icon: '◷',
    children: [
      {
        id: 'work-schedules',
        label: 'Horarios laborales',
        icon: '◴',
        route: '/labor-configuration/work-schedules',
        requiredPermission: 'configuracion_laboral.ver',
      },
      {
        id: 'overtime',
        label: 'Horas extra',
        icon: '◉',
        route: '/labor-configuration/overtime',
        requiredPermission: 'configuracion_laboral.ver',
      },
    ],
  },
];
